import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bonusomat-slots" }
const _hoisted_2 = {
  key: 0,
  class: "games-headline"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "bonusomat-slots__left" }
const _hoisted_5 = { class: "bonusomat-slots__right" }
const _hoisted_6 = {
  key: 0,
  class: "games-headline"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "bonusomat-slots__group"
}
const _hoisted_10 = {
  key: 0,
  class: "bonusomat-slots__text"
}
const _hoisted_11 = { class: "bonusomat-slots__text" }
const _hoisted_12 = { class: "bonusomat-slots__text" }
const _hoisted_13 = { class: "bonusomat-slots__text" }
const _hoisted_14 = { class: "bonusomat-slots__text--gray" }
const _hoisted_15 = { class: "bonusomat-slots__points" }
const _hoisted_16 = {
  key: 1,
  class: "bonusomat-slots__group"
}
const _hoisted_17 = { class: "bonusomat-slots__points" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "bonusomat-win-table__tables" }
const _hoisted_20 = { class: "bonusomat-win-table__section-grid" }
const _hoisted_21 = {
  key: 0,
  class: "bonusomat-win-table__section-joker"
}
const _hoisted_22 = { class: "bonusomat-win-table__allwyn-joker-img-wrap" }
const _hoisted_23 = {
  key: 0,
  class: "bonusomat-slots-bg"
}

import { computed, ref, onMounted, watch } from "vue";
import DsBottomSlotActionBar from "@sazka/design-system/src/bottom-slot/ds-bottom-slot-action-bar.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import DsTopSlotHeadlineSubheadline from "@sazka/design-system/src/top-slot/ds-top-subheadline.vue";
import TypographyHeadline from "@sazka/design-system/src/typography/typography-headline.vue";
import MobileAppLink from "@sazka/mobile-apps/components/mobile-app-link.vue";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { sazkaAlert } from "@sazka/utils/sazka-alert";
import { UrlUtils } from "@sazka/utils/url";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import { GamesAnalytics } from "@/games/analytics/analytics-games";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";
import BonusomatSlotsWinTable from "./bonusomat-slots-win-table.vue";
import BonusomatSpinModal from "./bonusomat-spin-modal.vue";
import useBonusomatData from "../../composables/use-bonusomat-data";
import useBonusomatLogoutCountdown from "../../composables/use-bonusomat-logout-countdown";
import useBonusomatLogoutData from "../../composables/use-bonusomat-logout-data";
import useBonusomatOnboarding from "../../composables/use-bonusomat-onboarding";
import useBonusomatSlotsBar from "../../composables/use-bonusomat-slots-bar";
import useBonusomatWinTables from "../../composables/use-bonusomat-win-tables";
import { bonImgUrl } from "../../utils/image-src";
import BonusomatRaffleCountersGroup from "../raffle/bonusomat-raffle-counters-group.vue";

const openSpinModalQueryParamName = "slots";

export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-slots',
  props: {
    isWidget: { type: Boolean },
    isLoggedIn: { type: Boolean }
  },
  setup(__props: any) {

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount, playerDataHasError, isPlayerDataLoaded, fulfilledTextInclined } =
    bonusomatPlayerStatus;

const { hasActiveQuest, deactivateQuest } = useBonusomatData();

const { openBonusomatOnboarding, setOnboardingAlreadyVisited } = useBonusomatOnboarding();

const { slotsWinTable, loadSlotsWinTable } = useBonusomatWinTables();

const { logoutDefaultDrawData, isLogoutDefaultDrawDataLoaded, loadDefaultDrawData } = useBonusomatLogoutData();
const { logoutDrawRemainingSeconds } = useBonusomatLogoutCountdown();

const { slotsBarSticky } = useBonusomatSlotsBar();

const isFoldable = useBreakpoints("sm");
const isLaptop = useBreakpoints("sm2");

const props = __props;

const slotsBar = ref<HTMLElement>(null);

if (props.isWidget && !props.isLoggedIn) {
    loadDefaultDrawData();
}

const spinModalIsOpen = ref(false);

const isSpinAvailable = computed(() => {
    return remainingSpinsCount.value > 0 && isPlayerDataLoaded.value;
});
const slotsMainImageUrl = computed(() => {
    return props.isWidget && !isSpinAvailable.value
        ? bonImgUrl("automat/automat", "png", "v=1")
        : bonImgUrl("slots/mr-green-bonusomat", "png");
});
const slotsMainImageAlt = computed(() => {
    return props.isWidget ? "Bonusomat" : "Pan Zelený stojící vedle Bonusomatu";
});
const slotsActiveQuestText = computed(() => {
    return isLaptop.value ? "Po dobu hraní Questu" : "Během Questu";
});
const isInactive = computed(() => {
    return hasActiveQuest.value && remainingSpinsCount.value === 0 && isPlayerDataLoaded.value;
});

const isModalOpen = ref(false);

const openModal = async () => {
    try {
        if (slotsWinTable.value) return;

        await loadSlotsWinTable();
    } catch (error) {
        sazkaAlert("Omlouváme se, při načítání tabulky výher nastala chyba.", "Zkuste to prosím později.");
    } finally {
        if (slotsWinTable.value) {
            isModalOpen.value = true;
        }

        BonusomatDatalayer.pushMoreInfoClick(
            "Tabulka výher",
            bonusomatPlayerData.value.points,
            remainingSpinsCount.value
        );
    }
};

const openBonusomatOnboardingClick = () => {
    openBonusomatOnboarding("slots");
    BonusomatDatalayer.pushMoreInfoClick("Bonusomat", bonusomatPlayerData.value.points, remainingSpinsCount.value);
};

const queryParams = new URLSearchParams(window.location.search);
if (queryParams.has(openSpinModalQueryParamName)) {
    setOnboardingAlreadyVisited();

    UrlUtils.clearUrlParams([openSpinModalQueryParamName]);
    spinModalIsOpen.value = true;
}

onMounted(() => {
    if (!props.isWidget) {
        slotsBarSticky(slotsBar.value, true);
    }
});

watch(
    bonusomatPlayerData,
    () => {
        if (props.isWidget) {
            GamesAnalytics.pushShowBonusomat(bonusomatPlayerData.value.points);
        }
    },
    { once: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      (_ctx.isWidget)
        ? (_openBlock(), _createBlock(TypographyHeadline, {
            key: 0,
            class: "bonusomat-slots__headline",
            type: "section",
            theme: "dark"
          }, {
            default: _withCtx(() => [
              (_ctx.isWidget)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(WebpImage, {
                      src: "/frontend/web/img/casino/icons/gift-green.png",
                      alt: "",
                      class: "games-headline__icon games-headline__icon--gift-green",
                      isLazyload: true,
                      width: 24,
                      height: 24
                    }),
                    _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "games-headline__title" }, "Bonusomat", -1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, "Bonusomat")),
              (!_ctx.isWidget)
                ? (_openBlock(), _createBlock(DsButton, {
                    key: 2,
                    type: "text",
                    theme: "dark",
                    "icon-right": "help",
                    onClick: openBonusomatOnboardingClick,
                    class: "button-onboarding"
                  }))
                : _createCommentVNode("", true),
              (!_ctx.isWidget)
                ? (_openBlock(), _createBlock(DsButton, {
                    key: 3,
                    theme: "dark",
                    type: "interaction",
                    size: "sm",
                    "icon-right": "gift",
                    onClick: openModal
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Tabulka výher ")
                    ])),
                    _: 1,
                    __: [8]
                  }))
                : _createCommentVNode("", true),
              (_ctx.isWidget)
                ? (_openBlock(), _createBlock(DsButton, {
                    key: 4,
                    theme: "dark",
                    type: "interaction",
                    size: "sm",
                    "icon-right": "arrow-right",
                    href: "/hry/bonusomat",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(GamesAnalytics).pushClickBonusomat(_unref(bonusomatPlayerData).points)))
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode(" Přejít k bonusomatu ")
                    ])),
                    _: 1,
                    __: [9]
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(WebpImage, {
          src: slotsMainImageUrl.value,
          alt: slotsMainImageAlt.value,
          "css-class": [
                    'bonusomat-slots__image',
                    {
                        'bonusomat-slots__image--hide-on-mobile': !_ctx.isWidget,
                        'bonusomat-slots__image--widget-with-spin': _ctx.isWidget && isSpinAvailable.value,
                    },
                ]
        }, null, 8, ["src", "alt", "css-class"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.isWidget)
          ? (_openBlock(), _createBlock(TypographyHeadline, {
              key: 0,
              class: "bonusomat-slots__headline",
              type: "section",
              theme: "dark"
            }, {
              default: _withCtx(() => [
                (_ctx.isWidget)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(WebpImage, {
                        src: "/frontend/web/img/casino/icons/gift-green.png",
                        alt: "",
                        class: "games-headline__icon games-headline__icon--gift-green",
                        isLazyload: true,
                        width: 24,
                        height: 24
                      }),
                      _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "games-headline__title" }, "Bonusomat", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, "Bonusomat")),
                (!_ctx.isWidget)
                  ? (_openBlock(), _createBlock(DsButton, {
                      key: 2,
                      type: "text",
                      theme: "dark",
                      "icon-right": "help",
                      onClick: openBonusomatOnboardingClick,
                      class: "button-onboarding"
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isWidget)
                  ? (_openBlock(), _createBlock(DsButton, {
                      key: 3,
                      theme: "dark",
                      type: "interaction",
                      size: "sm",
                      "icon-right": "gift",
                      onClick: openModal
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode(" Tabulka výher ")
                      ])),
                      _: 1,
                      __: [11]
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isWidget)
                  ? (_openBlock(), _createBlock(DsButton, {
                      key: 4,
                      theme: "dark",
                      type: "interaction",
                      size: "sm",
                      "icon-right": "arrow-right",
                      href: "/hry/bonusomat",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(GamesAnalytics).pushClickBonusomat(_unref(bonusomatPlayerData).points)))
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode(" Přejít k bonusomatu ")
                      ])),
                      _: 1,
                      __: [12]
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isWidget && !_ctx.isLoggedIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(BonusomatRaffleCountersGroup, {
                hasRaffleDataLoadingFailed: _unref(isLogoutDefaultDrawDataLoaded) && !_unref(logoutDefaultDrawData),
                showDefaultCounters: true,
                totalWin: _unref(logoutDefaultDrawData)?.totalWin,
                raffleRemainingSeconds: _unref(logoutDrawRemainingSeconds),
                showAllwynCounters: false,
                showTicketsCounters: false,
                isWidget: _ctx.isWidget
              }, null, 8, ["hasRaffleDataLoadingFailed", "totalWin", "raffleRemainingSeconds", "isWidget"])
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["bonusomat-slots__action-bar", {
                    'bonusomat-slots__action-bar--inactive': isInactive.value,
                    'bonusomat-slots__action-bar--spin': isSpinAvailable.value,
                    'bonusomat-slots__action-bar--error': _unref(playerDataHasError),
                    'bm-slots-bar-sticky-on-mobile': !_ctx.isWidget,
                }]),
              ref_key: "slotsBar",
              ref: slotsBar
            }, [
              _createVNode(WebpImage, {
                src: _unref(bonImgUrl)('slots/bonusomat-slots', 'png'),
                alt: "Bonusomat",
                class: "bonusomat-slots__bar-image"
              }, null, 8, ["src"]),
              _createVNode(DsIcon, {
                name: "b-mat",
                class: "bonusomat-slots__bar-icon"
              }),
              (_unref(isPlayerDataLoaded))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_unref(playerDataHasError))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Omlouváme se, při načítání bodů nastala chyba. "))
                      : (isInactive.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("span", null, _toDisplayString(slotsActiveQuestText.value), 1),
                              _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "bonusomat-slots__text--thin" }, " je Bonusomat neaktivní", -1))
                            ]),
                            _createVNode(DsButton, {
                              size: "sm",
                              type: "error",
                              "icon-right": "cross",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(deactivateQuest)('main')))
                            }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createTextVNode(" Ukončit Quest ")
                              ])),
                              _: 1,
                              __: [15]
                            })
                          ], 64))
                        : (isSpinAvailable.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("div", _hoisted_12, [
                                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "bonusomat-slots__text--thin" }, "K dispozici", -1)),
                                _createTextVNode(" " + _toDisplayString(_unref(remainingSpinsCount)) + " zatočení ", 1)
                              ]),
                              _createVNode(DsButton, {
                                size: "sm",
                                "icon-right": "rotate",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (spinModalIsOpen.value = !spinModalIsOpen.value))
                              }, {
                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                  _createTextVNode(" Získat odměnu ")
                                ])),
                                _: 1,
                                __: [17]
                              })
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(fulfilledTextInclined)), 1),
                                _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_unref(bonusomatPlayerData).points) + " z 5 úkolů ", 1)
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bonusomatPlayerData).points, (index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "bonusomat-slots__point bonusomat-slots__point--completed",
                                    key: index
                                  }, [
                                    _createVNode(DsIcon, { name: "check" })
                                  ]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - _unref(bonusomatPlayerData).points, (index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "bonusomat-slots__point",
                                    key: index
                                  }, _toDisplayString(_unref(bonusomatPlayerData).points + index), 1))
                                }), 128))
                              ])
                            ], 64))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "bonusomat-slots__text" }, [
                      _createElementVNode("div", { class: "bonusomat-slots__text--placeholder bonusomat-placeholder__skeleton" }),
                      _createElementVNode("div", { class: "bonusomat-slots__text--placeholder bonusomat-placeholder__skeleton" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                        return _createElementVNode("div", {
                          class: "bonusomat-slots__point bonusomat-slots__point--placeholder bonusomat-placeholder__skeleton",
                          key: index,
                          style: _normalizeStyle({
                                animationDelay: `${0.2 + index * 0.1}s`,
                            })
                        }, null, 4)
                      }), 64))
                    ])
                  ]))
            ], 2))
      ]),
      _createVNode(DsModalDialog, {
        modelValue: isModalOpen.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isModalOpen).value = $event)),
        "css-class": ['bonusomat-win-table', _unref(slotsWinTable)?.jokerSection ? 'bonusomat-win-table--with-joker' : ''],
        theme: "dark"
      }, {
        top: _withCtx(() => [
          _createVNode(DsTopSlotHeadlineSubheadline, {
            headline: _unref(slotsWinTable)?.title
          }, null, 8, ["headline"]),
          _createElementVNode("p", {
            class: "bonusomat-win-table__description",
            innerHTML: _unref(slotsWinTable)?.description
          }, null, 8, _hoisted_18)
        ]),
        content: _withCtx(() => [
          _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "bonusomat-win-table__label" }, "Co můžete vyhrát?", -1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slotsWinTable)?.sections, (section, index) => {
                return (_openBlock(), _createBlock(BonusomatSlotsWinTable, {
                  key: index,
                  "show-header": index === 0 || (index === 1 && _unref(isFoldable)),
                  "row-one-text": section.row1.text,
                  "row-one-image": section.row1.image,
                  "row-two-text": section.row2.text,
                  "row-two-image": section.row2.image,
                  "row-three-text": section.row3.text,
                  "row-three-image": section.row3.image
                }, null, 8, ["show-header", "row-one-text", "row-one-image", "row-two-text", "row-two-image", "row-three-text", "row-three-image"]))
              }), 128))
            ]),
            (_unref(slotsWinTable)?.jokerSection)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(BonusomatSlotsWinTable, {
                    "show-header": true,
                    "row-one-text": _unref(slotsWinTable).jokerSection.row1.text,
                    "row-one-image": _unref(slotsWinTable).jokerSection.row1.image,
                    "row-two-text": _unref(slotsWinTable).jokerSection.row2.text,
                    "row-two-image": _unref(slotsWinTable).jokerSection.row2.image,
                    "row-three-text": _unref(slotsWinTable).jokerSection.row3.text,
                    "row-three-image": _unref(slotsWinTable).jokerSection.row3.image
                  }, null, 8, ["row-one-text", "row-one-image", "row-two-text", "row-two-image", "row-three-text", "row-three-image"]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(WebpImage, {
                      src: "/frontend/web/img/logos/allwyn/allwyn-joker-logo-white.svg",
                      alt: "allwyn Joker logo"
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        bottom: _withCtx(() => [
          _createVNode(DsBottomSlotActionBar, {
            "has-btn-close": false,
            "has-btn-submit": false
          }, {
            additional: _withCtx(() => [
              _createVNode(MobileAppLink, {
                href: _unref(slotsWinTable).rules,
                target: "_blank",
                "event-name": "openPdf",
                "event-argument": _unref(slotsWinTable).rules,
                class: "bonusomat-win-table__button-rules button button--primary button--dark button--sm button--icon",
                "icon-right": "arrow-right-thin",
                "open-in-new-tab": true,
                onLinkClicked: _cache[4] || (_cache[4] = ($event: any) => (
                                _unref(BonusomatDatalayer).pushClickWinRules(_unref(bonusomatPlayerData).points, _unref(remainingSpinsCount))
                            ))
              }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createTextVNode("Kompletní pravidla")
                ])),
                _: 1,
                __: [21]
              }, 8, ["href", "event-argument"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "css-class"]),
      _createVNode(BonusomatSpinModal, {
        modelValue: spinModalIsOpen.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((spinModalIsOpen).value = $event)),
        onOpenWinTable: openModal
      }, null, 8, ["modelValue"])
    ]),
    (_ctx.isWidget)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23))
      : _createCommentVNode("", true)
  ], 64))
}
}

})